import { Category, Meal } from '../types';

export const findProductInCategories = (productId: number, categories: Category[]) =>
  categories.flatMap(({ products }) => products).find(product => product?.id === productId);

export const findProductInMeals = (productId: number, meals: Meal[]) =>
  meals
    .flatMap(({ courseMealChoices }) => courseMealChoices.flatMap(({ products }) => products))
    .find(product => product?.id === productId);
